import React, { memo } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { FormGroup, SectionGroup } from '@bingads-webui-cc-react/layout';
import type { WireInstructionDetail, WireInstructionSectionProps } from './types';

function WireInstructionSectionUnwrapped({
  i18n,
  bankName,
  wireDetails,
}: WireInstructionSectionProps) {
  return (
    <SectionGroup name="wire-instruction" title={i18n.getString(_TL_('Wire transfer instructions'))}>
      <FormGroup id="wire-what-to-expect" label={i18n.getString(_TL_('What to expect'))}>
        {i18n.getString(_TL_('It can take up to 5 days after the wire transfer is complete for the funds to appear in your Microsoft Advertising account.'))}
      </FormGroup>
      {bankName && (
        <FormGroup id="bank-name" label={i18n.getString(_TL_('Bank name'))}>
          {bankName}
        </FormGroup>
      )}
      {_.map(wireDetails, ({
        Label,
        Content,
      }: WireInstructionDetail, index: number) => (
        <FormGroup key={index} id={`wire-details-${index}`} label={Label}>
          {Content}
        </FormGroup>
      ))}
    </SectionGroup>
  );
}

WireInstructionSectionUnwrapped.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  bankName: PropTypes.string,
  wireDetails: PropTypes.arrayOf(PropTypes.shape({
    Label: PropTypes.string,
    Content: PropTypes.string,
  })),
};

WireInstructionSectionUnwrapped.defaultProps = {
  bankName: '',
  wireDetails: [],
};

export const WireInstructionSection = memo(WireInstructionSectionUnwrapped);
